import React from "react";
import Divider from "@/components/divider";
import ErrorComponent from "@/components/empty/ErrorComponent";
import { SelectedSport } from "@/graphql/gql/graphql";
import FeaturedSport from "./FeaturedSport";
import styles from "./sportSection.module.scss";

type SportSectionProps = {
  selectedSports: SelectedSport[];
};

const SportSection = ({ selectedSports }: SportSectionProps) => (
  <div className={styles.container}>
    {selectedSports.length === 0 ? (
      <div className={styles.boxError}>
        <ErrorComponent />
      </div>
    ) : (
      selectedSports.map((sport, index) => (
        <React.Fragment key={sport.sport.slug}>
          <FeaturedSport selectedSport={sport} />
          {index === selectedSports.length - 1 ? null : (
            <div className={styles.boxDivider}>
              <Divider />
            </div>
          )}
        </React.Fragment>
      ))
    )}
  </div>
);

export default SportSection;
